import { IFeatureBoxes } from "@/api/AppApi/services/home/interfaces/IFeatureBox";
import { Col, Row } from "@/utils/bootstrap";
import FeatureBox from "./FeatureBox";

interface Props extends IFeatureBoxes {}

const PCFeatureBoxes = (props: Props) => {
  return (
    <Row className="m-0 d-flex justify-content-center" style={{ gap: 16 }}>
      {props.data?.map((child, key) => (
        <Col className="p-0 col-auto" key={key}>
          <FeatureBox {...child} />
        </Col>
      ))}
    </Row>
  );
};

export default PCFeatureBoxes;
